import clsx from "clsx";
import { ChevronDown } from "lucide-react";
import { ElementType, useContext } from "react";
import { twMerge } from "tailwind-merge";
import Button, { ButtonProps } from "../button";
import ControlGroupButton from "../controlgroup/controlGroupButton";
import { DropdownContext } from "./dropdown";

export interface DropdownToggleProps extends ButtonProps {
  as?: "Button" | "ControlGroupButton";
  toggleEnabled?: boolean;
  noStyle?: boolean;
  noIndicator?: boolean;
  typeable?: boolean;
}

const DropdownToggle = (props: Readonly<DropdownToggleProps>) => {
  const {
    className,
    toggleEnabled = true,
    children,
    as,
    noStyle,
    noIndicator,
    disabled,
    typeable,
    onClick,
    ...rest
  } = props;
  const { isOpen, floatingRefs, getReferenceProps } =
    useContext(DropdownContext);
  const resolvedAs = as ?? "Button";

  const referenceProps = getReferenceProps();
  const clicked = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) return;
    (referenceProps["onClick"] as Function)?.call(this, e);
    onClick?.(e);
  };

  const ButtonComponent =
    resolvedAs === "ControlGroupButton" ? ControlGroupButton : Button;
  const Component = noStyle ? ("div" as ElementType) : ButtonComponent;

  return (
    <Component
      {...rest}
      ref={floatingRefs!.setReference}
      {...referenceProps}
      disabled={disabled}
      onClick={clicked}
      className={twMerge(
        clsx("whitespace-nowrap", {
          "cursor-pointer": !typeable,
        }),
        className,
      )}
    >
      {children}{" "}
      {!noIndicator && toggleEnabled && (
        <ChevronDown
          size={15}
          className={clsx("transition-all shrink-0", { "rotate-180": isOpen })}
        />
      )}
    </Component>
  );
};

export default DropdownToggle;
